import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import DocsLink from '../../common/custom/DocsLink';
import ParentDocCard from '../common/ParentDocCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { EVENT } from 'drapcode-constant';
import voca from 'voca';
import { collectionTypeBadge, descriptionTooltip, inUseTooltip } from '../../common/utils/validate';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class DefaultPage extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { page: 0 };

  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    if (projectId) {
      this.props.actions.loadEvents({ projectId, page: this.state.page, version });
    }
    this.props.actions.getPermissionFlags({ projectId });
  }

  onPageChange = (val) => {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadEvents({
      projectId,
      version,
      page: val.selected,
    });
    this.setState({ page: val.selected });
  };

  handleDelete = (uuid) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteEvent({ projectId, uuid, version }).then((res) => {
        actions.loadEvents({ projectId, page: this.state.page, version });
        history.push(`/events/${version}/v/${projectId}`);
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  render() {
    const { events, loadEventsPending, totalPages, permissionFlags } = this.props.events;
    const { projectId, version } = this.props.match.params;
    let flag;

    if (permissionFlags && permissionFlags.length > 0) {
      flag = permissionFlags.includes(EVENT);
    }
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div className="card-header card-header-icon" data-background-color="drapcode-violet">
                <i className={`wb ${drapcodeIcon('events')}`}></i>
              </div>
              <div className="card-content">
                <div className="card-title-header">
                  <h4 className="card-title">Events</h4>
                  <div className="card-cta">
                    <Link
                      className={`btn btn-theme-submit btn-md ${isReadOnly ? 'disabled' : ''}`}
                      to={isReadOnly ? '#' : `/events/${version}/v/${projectId}/create`}
                      title={isReadOnly ? 'Read-Only Mode' : 'Create Event'}
                      onClick={(e) => {
                        if (isReadOnly) {
                          e.preventDefault();
                        }
                      }}
                    >
                      <i className="wb webconnect-plus"></i> Create Event
                    </Link>
                  </div>
                </div>
                {loadEventsPending ? (
                  <div className="text-center">
                    <CustomLoader loading={loadEventsPending} size="20px" color="#303453" />
                  </div>
                ) : (
                  <Fragment>
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover table-sm table-word-break">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>
                              Description{' '}
                              <TooltipInfo
                                title={descriptionTooltip('event')}
                                headerText={`What's Description?`}
                                showHeader={true}
                                showArrow={true}
                              />
                            </th>
                            <th>
                              In Use{' '}
                              <TooltipInfo
                                title={inUseTooltip('event')}
                                headerText={`What's In Use?`}
                                showHeader={true}
                                showArrow={true}
                              />
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {events && events.length > 0 ? (
                            events.map(({ uuid, eventTitle, description, inUse = true }) => (
                              <tr key={uuid}>
                                <td className="align-middle" style={{ width: '30%' }}>
                                  {eventTitle}
                                </td>
                                <td
                                  className="align-middle"
                                  title={description}
                                  style={{ width: '60%' }}
                                >
                                  {voca.truncate(`${description}`, 80)}
                                </td>
                                <td className="align-middle" style={{ width: '15%' }}>
                                  {collectionTypeBadge(inUse, 'inuse', 'event')}
                                </td>
                                <td className="align-middle text-right">
                                  <Link
                                    className="btn btn-primary btn-xs"
                                    to={`/events/${version}/v/${projectId}/event/${uuid}`}
                                    title={`Edit ${eventTitle}`}
                                  >
                                    <i className={`wb ${drapcodeIcon('edit')}`} size={'md'}></i>
                                  </Link>
                                  &nbsp;
                                  <button
                                    type="button"
                                    className="btn btn-xs btn-theme-delete"
                                    title={isReadOnly ? 'Read-Only Mode' : `Delete ${eventTitle}`}
                                    style={{
                                      cursor: flag && !isReadOnly ? 'pointer' : 'not-allowed',
                                    }}
                                    onClick={() =>
                                      flag && !isReadOnly ? this.handleDelete(uuid) : undefined
                                    }
                                    disabled={isReadOnly}
                                  >
                                    <i className={`wb ${drapcodeIcon('delete')}`} size={'md'}></i>
                                    {flag ? null : (
                                      <>
                                        &nbsp;
                                        <TooltipInfo
                                          title={description}
                                          headerText={`Permission Disabled!`}
                                          showHeader={true}
                                          showArrow={true}
                                        />
                                      </>
                                    )}
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="align-middle text-center">
                                No Events!
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (
                        <div className="row mx-0">
                          <div className="col-md-3"></div>
                          <div className="col-md-6 text-center">
                            <CustomReactPaginate
                              totalPages={totalPages}
                              pageRangeDisplayed={10}
                              marginPagesDisplayed={2}
                              page={this.state.page}
                              onPageChange={this.onPageChange}
                            />
                          </div>
                          <div className="col-md-3"></div>
                        </div>
                      )}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <ParentDocCard>
            <h5>
              <b>About Events</b>
            </h5>
            <p>
              Allows you to create multiple automated workflows for varied purposes such as to save,
              update and delete collection data, add & remove data from a collection, show/close
              modal, notifications, page reload, page refresh, show/hide components etc. You can
              create events to add dependent dropdown and send dynamic emails.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-event/event-introduction" />
            <br />
            <br />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
